import React from 'react';

export default function CreditMeter({ credits, maxCredits, showWarning = true }) {
  const pct     = maxCredits > 0 ? Math.min(100, (credits / maxCredits) * 100) : 0;
  const isRed   = credits < 2;
  const isAmber = !isRed && credits < 5;
  const color   = isRed ? 'red' : isAmber ? 'amber' : 'green';

  return (
    <div className="credit-meter-bar-only">
      <div className="cm-bar-wrap">
        <div
          className={`cm-bar-fill ${color}`}
          style={{ width: `${pct}%` }}
        />
      </div>
      <div className="cm-bar-legend">
        <span>0 cr</span>
        <span>{maxCredits} cr (plan max)</span>
      </div>
      {showWarning && isRed && (
        <div className="cm-warning">
          <span>⚠️</span>
          <span>
            You have fewer than 2 credits — top up to keep your services running.
          </span>
        </div>
      )}
    </div>
  );
}
